import { createContext } from 'react'

export const gapiContext = createContext<boolean>(false)
